/* eslint-disable */
var createElementIcon  = function (createElement) {
    return createElement('i', {
        attrs: {
            class: 'el-icon-warning'
        },
        style: {
            'font-Size': '30px',
            'color': '#FD2C2C',
        },
    })
}
var createElementSpan  = function (createElement,text) {
    return createElement('span', {
        domProps:{
            innerHTML: text
        },
        style: {
            'font-size': '1.5rem',
            'color':'#323232',
            'margin-left': '1.5rem'
        },
        props: {
            text: '操作成功'
        }
    })
}
var createElementOkBtn  = function (h,txt,confirm) {
    return h.$createElement('button', {
        attrs: {
            value: txt,
            id: 'confirm',
            innerHTML: txt,
        },
        on: {
            click:function(event){
                success(h,event,confirm)
            }
        }
    })
}

var createElementCancelBtn  = function (h,txt,cancel) {
    return h.$createElement('button', {
        attrs: {
            value: txt,
            id: 'cancel',
            innerHTML: txt
        },
        on: {
            click:function(event){
                cancelEvent(h,event,cancel)
            }
        }
    })
}

function success(h,e,confirm){
    // console.log('confirm');
    if(confirm){
        confirm()
    }
    let app = h.app
    app.removeAttribute('style')
    document.body.removeChild(h.modelM)
    document.body.removeChild(h.modal)
}

function cancelEvent(h,e,cancel){
    console.log('cancel');
    if(cancel){
        cancel()
    }
    let app = h.app
    app.removeAttribute('style')
    document.body.removeChild(h.modelM)
    document.body.removeChild(h.modal)
}
function showModal(data){
    createEle(data)
}
function createEle(data){
    let {h,text,confirmText,cancelText,confirm,cancel} = data
    let _createElement = h.$createElement
    // let $el = h.$el
    let domObj;
    domObj = _createElement(
        'div',
        {
            attrs: {
                id: 'modal',
            }
        },
        [
            _createElement(
                'div',
                {
                    attrs: {
                        id: 'titleC',
                    }
                },
                [
                    createElementIcon(_createElement),
                    createElementSpan(_createElement, text || '温馨提示')
                ]
            ),
            _createElement(
                'div',
                {
                    attrs: {
                        id: 'btnC',
                    }
                },
                [
                    createElementOkBtn(h, confirmText || '确定',confirm),
                    createElementCancelBtn(h,cancelText || '取消',cancel)
                ]
            )
        ]
    )
    let results = render(domObj)
    let divM = document.createElement('div')
    divM.setAttribute('id','v-model')
    h.modelM = divM
    h.modal = results
    document.body.appendChild(divM)
    document.body.appendChild(results)
    let app = document.getElementById('app')
    app.setAttribute('style','height:100vh;overflow:hidden')
    h.app = app
}
function render(domObj){
    let el = document.createElement(domObj.tag);
    let keys = Object.assign(domObj.data)
    for(let i in keys){
        if(i == 'style'){
            setAttr(el, i, keys[i]);
        }else{
            for (let key in keys[i]) {
                setAttr(el, key, keys[i][key]);
            }
        }
    }
    if(domObj.children){
        domObj.children.forEach(child => {
            child =  render(child)
            el.appendChild(child);
        });
    }
    return el
}
// 设置属性或事件
function setAttr(node, key, value) {
    switch(key) {
        case 'value':
            if (node.tagName.toLowerCase() === 'input' ||
                node.tagName.toLowerCase() === 'textarea') {
                node.value = value;
            } else {
                node.setAttribute(key, value);
            }
            break;
        case 'style':
            // 直接赋值行内样式
            var str = ''
            for(let s in value){
                str +=  s+ ':' + value[s] + ';'
            }
            node.setAttribute(key,str)
            break;
        case 'innerHTML':
            node.innerHTML = value;
            break;
        case 'click':
            node.addEventListener(key,value);
            break
        default:
            node.setAttribute(key, value);
            break;
    }
}

export default showModal
